export const RECEIVED_NUMBER_IDENTIFIER =
  "urn:tag:system:ReceivedFaxDetail:receiverNumber";
export const CREATED_BY_IDENTIFIER = "createdByUserId";
